import ActionTypes from '../constants/PlaylistT3';

export function annotatePlaylists({ pandoraIds }) {
  return {
    type: ActionTypes.ANNOTATE_PLAYLISTS,
    data: { pandoraIds },
  };
}

export function appendItemsToPlaylist({ pandoraId, playlistVersion, itemPandoraIds }) {
  return {
    type: ActionTypes.APPEND_ITEMS,
    data: { pandoraId, playlistVersion, itemPandoraIds },
  };
}

export function updateOptimisticGetTracksRetry({ playlistId }) {
  return {
    type: ActionTypes.UPDATE_OPTIMISTIC_GET_TRACKS_RETRY,
    data: { playlistId },
  };
}

export function createPlaylist({ name, description, secret, isPrivate, itemPandoraIds }) {
  return {
    type: ActionTypes.CREATE_PLAYLIST,
    data: { name, description, secret, isPrivate, itemPandoraIds },
  };
}

export function unlockPlaylistAndNotify(playlist) {
  return {
    type: ActionTypes.UNLOCK_PLAYLIST_AND_NOTIFY,
    data: { playlist },
  };
}

export function deletePlaylist({ pandoraId, redirectToMyMusicPlaylists = false }) {
  return {
    type: ActionTypes.DELETE_PLAYLIST,
    data: { pandoraId, redirectToMyMusicPlaylists },
  };
}

export function confirmDeletePlaylist({ pandoraId, redirectToMyMusicPlaylists = false }) {
  return {
    type: ActionTypes.CONFIRM_DELETE_PLAYLIST,
    data: { pandoraId, redirectToMyMusicPlaylists },
  };
}

export function deleteTrackFromPlaylist({ playlistId, playlistVersion, itemId, trackIndex }) {
  return {
    type: ActionTypes.DELETE_TRACK,
    data: { playlistId, playlistVersion, itemId, trackIndex },
  };
}

export function getAutofillTracksForPlaylist({ playlistId, playlistVersion, numSongs }) {
  return {
    type: ActionTypes.GET_PLAYLIST_AUTOFILL_TRACKS,
    data: { playlistId, playlistVersion, numSongs },
  };
}

export function getRecommendationsForPlaylist({ pandoraId, numSongs }) {
  return {
    type: ActionTypes.GET_PLAYLIST_RECOMMENDATIONS,
    data: {
      pandoraId,
      numSongs,
    },
  };
}

export function getTracksForPlaylist({
  pandoraId,
  version,
  offset = 0,
  limit = 100,
  annotationLimit,
}) {
  return {
    type: ActionTypes.GET_TRACKS,
    data: { pandoraId, version, offset, limit, annotationLimit },
  };
}

export function clearTracksForPlaylist(pandoraId) {
  return {
    type: ActionTypes.CLEAR_PLAYLIST_TRACKLIST,
    data: { pandoraId },
  };
}

export function insertTrackInPlaylist({ playlistId, playlistVersion, trackId, trackIndex }) {
  return {
    type: ActionTypes.INSERT_TRACK,
    data: { playlistId, playlistVersion, trackId, trackIndex },
  };
}

export function intentAddTrackForFeedback({ playlistId, trackId }) {
  return {
    type: ActionTypes.INTENT_ADD_TRACK_FOR_FEEDBACK,
    data: { playlistId, trackId },
  };
}

export function intentDeleteTrackForFeedback({ playlistId, trackItemId }) {
  return {
    type: ActionTypes.INTENT_DELETE_TRACK_FOR_FEEDBACK,
    data: { playlistId, trackItemId },
  };
}

export function moveTrackInPlaylist({
  playlistId,
  playlistVersion,
  oldTrackIndex,
  newTrackIndex,
  itemId,
  tracks,
}) {
  return {
    type: ActionTypes.MOVE_TRACK,
    data: {
      playlistId,
      playlistVersion,
      oldTrackIndex,
      newTrackIndex,
      itemId,
      tracks,
    },
  };
}

export function onFeedbackUpdateCompletion({ playlist }) {
  return {
    type: ActionTypes.ON_FEEDBACK_UPDATE_COMPLETION,
    data: { playlist },
  };
}

export function setPlaylistDetails({ pandoraId, version, name, description, secret, isPrivate }) {
  return {
    type: ActionTypes.SET_DETAILS,
    data: { pandoraId, version, name, description, secret, isPrivate },
  };
}

export function makeOptimisticEdit({ moves, inserts, id }) {
  return {
    type: ActionTypes.MAKE_OPTIMISTIC_EDIT,
    data: {
      moves,
      inserts,
      id,
    },
  };
}

export function rollbackOptimisticEdit({ previousTracks, previousTotalTracks, id }) {
  return {
    type: ActionTypes.ROLLBACK_OPTIMISTIC_EDIT,
    data: {
      previousTracks,
      previousTotalTracks,
      id,
    },
  };
}

export function makeOptimisticDelete({ pandoraId, playlistVersion, trackItemIds }) {
  return {
    type: ActionTypes.MAKE_OPTIMISTIC_DELETE,
    data: { pandoraId, version: playlistVersion, trackItemIds },
  };
}

export function deleteOptimisticPlaylistData({ id }) {
  return {
    type: ActionTypes.DELETE_OPTIMISTIC_PLAYLIST_DATA,
    data: { id },
  };
}

export function setAreVoiceTracksEnabled({ playlistId, areVoiceTracksEnabled }) {
  return {
    type: ActionTypes.SET_ARE_VOICE_TRACKS_ENABLED,
    data: {
      playlistId,
      areVoiceTracksEnabled,
    },
  };
}
